import api from "api";
import { useQuery } from "react-query";

const apiBase = process.env.REACT_APP_API_URL_V2 + "/v2";

const useGetExercise = (exercise_id?: number) => {
  const key = "getExercise" + exercise_id;

  return useQuery(
    key,
    () =>
      // @ts-ignore
      api.parse(`GET support/exercises/${exercise_id}`, {
        root: apiBase,
      }),
    {
      enabled: !!exercise_id,
    }
  );
};

export default useGetExercise;
